import { CASTracker } from '../../cimsPage/instances/cas'
import { ConcreteTestSets } from '../../cimsPage/instances/concrete'
import { DSLog } from '../../cimsPage/instances/ds'
import { FDCTracker } from '../../cimsPage/instances/fdc'
import { CustomFieldEntityItem } from './CustomFieldEntityItem'

export const DS = new CustomFieldEntityItem({
  id: 'A9AEC3B2-57DC-4BC4-BB86-3E604F48CDE9',
  type: 'Design Submittal',
  classType: 'DesignSubmittal',
  key: 'id',
  label: 'sharePointFolderName',
  page: DSLog,
})
export const CAS = new CustomFieldEntityItem({
  id: '2B627113-9CDC-4B43-9878-C60E1A29B274',
  type: 'Construction & Admin Submittal',
  classType: 'ConstructionAdminSubmittal',
  key: 'id',
  label: 'sharePointFolderName',
  page: CASTracker,
})
export const FDC = new CustomFieldEntityItem({
  id: 'A5853A67-7AD1-4606-B703-1C099572E836',
  type: 'Field Design Change',
  classType: 'FieldDesignChange',
  key: 'id',
  label: 'formattedNumber',
  page: FDCTracker,
})
export const CTS = new CustomFieldEntityItem({
  id: '51FD9D74-A54D-43D6-A615-048731AAA74A',
  type: 'Concrete Test Set',
  classType: 'ConcreteTestSet',
  label: 'testSetId',
  key: 'globalId',
  page: ConcreteTestSets,
})
